import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import CryptoJS from "crypto-js";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const AES_KEY = "7D3B8E69F1A84B7EA8A3F6792B44C926";
const AES_IV = "A1B2C3D4E5F60718";

const decryptText = (encryptedText) => {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV);
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

const AdminNavBar = () => {
  const [adminName, setAdminName] = useState("");
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  useEffect(() => {
    let session = localStorage.getItem("adminLogsessiondetails") || localStorage.getItem("adminsessiondetails");
    if (session) {
      try {
        const decrypted = decryptText(session);
        const parsed = JSON.parse(decrypted);
        if (parsed.StaffCode) setAdminName(parsed.StaffCode);
      } catch {
        setAdminName("");
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("adminLogsessiondetails");
    localStorage.removeItem("adminsessiondetails");
    window.location.href = "/BasicAuth";
  };

  return (
    <MDBox display="flex" alignItems="center" justifyContent="space-between" px={4} py={2} sx={{ background: '#fff', boxShadow: 2, borderRadius: 3, mb: 3, minHeight: 64 }}>
      <MDBox display="flex" alignItems="center">
        <Avatar sx={{ width: 40, height: 40, bgcolor: 'info.main' }}>
          <PersonIcon sx={{ color: '#fff' }} />
        </Avatar>
        <MDTypography variant="h6" fontWeight="medium" color="primary" ml={2}>
          {adminName ? `Hi, ${adminName}` : "Admin"}
        </MDTypography>
      </MDBox>
      <IconButton color="error" onClick={() => setLogoutDialogOpen(true)} title="Logout">
        <LogoutIcon />
      </IconButton>
      <Dialog open={logoutDialogOpen} onClose={() => setLogoutDialogOpen(false)}>
        <DialogTitle>Logout Confirmation</DialogTitle>
        <DialogContent>Are you sure you want to logout?</DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutDialogOpen(false)} color="info">Cancel</Button>
          <Button onClick={handleLogout} color="error" variant="contained">Logout</Button>
        </DialogActions>
      </Dialog>
    </MDBox>
  );
};

export default AdminNavBar; 